module.exports = __webpack_public_path__ + "static/media/Results-7.7fb02a2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proof/Results-7.jpg
// module id = 370
// module chunks = 0